import { Component, OnInit, OnDestroy } from '@angular/core';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { UpdateinfoService } from 'src/app/services/updateinfo.service';
import { SmartyAddressService } from 'src/app/services/smarty-address.service';
import { Updatepersonalinfo, GetRacesDropdownsModel, GetEnthincitiesDropdownsModel, GetLanguageDropdownsModel, SearchPatientPharmacyModel, GetETHNICITIES, Getpharmacies } from 'src/app/models/updatepersonalinfo/updatepersonalinfo';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;
@Component({
  selector: 'app-update-record',
  templateUrl: './update-record.component.html',
  styleUrls: ['./update-record.component.css']
})
export class UpdateRecordComponent implements OnInit, OnDestroy {
  pageNum: any;
  totalPages: any;
  patientpersonalinfo: any;
  Updatepersonalinfo: Updatepersonalinfo;
  // CityandStateRequest: CityandStateRequest;
  GetETHNICITIES: any;
  Getpharmacies: any = [];
  addressOptions: any = [];
  SearchPatientPharmacyModel: SearchPatientPharmacyModel;
  getEnthincitiesDropdownsModel: any;
  getLanguageDropdownsModel: any;
  searchLanguageFC: any;
  race1: any = '';
  race2: any = '';
  race3: any = '';
  RacesSearch: any;
  searchRacesFC: any;
  isLoading: boolean = false;
  filterSearchRacesList: any;
  getRacesDropdownsModel: any;
  _cityandstate: any;
  //selectedState: any = 'state';
  isZipCode: boolean = false;
  cell_phone_formated: any;
  isCellPhoneAvailable: boolean = true;
  practiceState: any = '';
  practiceCity: any = '';
  practiceZip: any = '';
  DrivinglicenseData: any;

  constructor(private smarty: SmartyAddressService, private translateService: TranslateService, private _phrutilService: PhrutillsService, private UpdateinfoService: UpdateinfoService, private spinner: NgxSpinnerService
    , private route: Router) {
    this.Updatepersonalinfo = new Updatepersonalinfo;
    //this.CityandStateRequest = new CityandStateRequest;
    this.SearchPatientPharmacyModel = new SearchPatientPharmacyModel;
    let info = localStorage.getItem('PersonalInfo');
    if (!info) {
      this.route.navigateByUrl("/");
      return;
    }
    let pagesorder = localStorage.getItem('pagesorder');
    this.pageNum = JSON.parse(pagesorder ? pagesorder : '').update_info;
    this.totalPages = localStorage.getItem('totalPages');
  }

  ngOnDestroy(): void {
    let info = localStorage.getItem('PersonalInfo');
    if (!info) {
      return;
    }
    let personalInfo = this._phrutilService.decrypt(info);
    if (personalInfo.isEditProfilePic) {
      personalInfo.isEditProfilePic = false;
      let data = this._phrutilService.encrypt(personalInfo);
      localStorage.setItem('PersonalInfo', data);
      this.UpdateinfoService.onIsEditProfilePic();
    }
  }

  ngOnInit(): void {

    this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PersonalInfo'));
   // console.log("patientpersonalinfo ", this.patientpersonalinfo);
    if (localStorage.getItem('licensedata')) {
      this.DrivinglicenseData = this._phrutilService.decrypt(localStorage.getItem('licensedata'));

      if (this.patientpersonalinfo.ZIP == "" || this.patientpersonalinfo.ZIP ==null) {
        this.patientpersonalinfo.ZIP = this.DrivinglicenseData.Data['Zip Code'];
        //this.patientpersonalinfo.ZIP ='10005';
      }

      if (this.patientpersonalinfo.CITY == "" || this.patientpersonalinfo.CITY == null) {
        this.patientpersonalinfo.CITY = this.DrivinglicenseData.Data.City;
      }
      if (this.patientpersonalinfo.STATE == "" || this.patientpersonalinfo.STATE == null) {
        this.patientpersonalinfo.STATE = this.DrivinglicenseData.Data.State;
      }
      if (this.patientpersonalinfo.ADDRESS == "" || this.patientpersonalinfo.ADDRESS == null) {
        this.patientpersonalinfo.ADDRESS = this.DrivinglicenseData.Data.Address;
      }
      //console.log(this.DrivinglicenseData);
    }
  
    //console.log(this.patientpersonalinfo);
    const state = localStorage.getItem('state')
    if (state != undefined || state != null) {
      this.practiceState = state;
    }
    const city = localStorage.getItem('city')
    if (city != undefined || city != null) {
      this.practiceCity = city;
    }
    const zip = localStorage.getItem('zip')
    if (zip != undefined || zip != null) {
      this.practiceZip = zip;
    }

    this.patientpersonalinfo.isEditProfilePic = true;
    let data = this._phrutilService.encrypt(this.patientpersonalinfo);

    localStorage.setItem('PersonalInfo', data);
    this.GetPatientData();
    this._phrutilService.patientlanguage$.subscribe(language => {
      //console.log("lang update 1st "+language);
      if (this.Updatepersonalinfo.LANGUAGE == 'English' || this.Updatepersonalinfo.LANGUAGE == 'Spanish') {
        // console.log("orignal lang " + this.Updatepersonalinfo.LANGUAGE);
        console.log(language + " language");
        if (language == "es") {
          // console.log("lang update es" + language);
          this.Updatepersonalinfo.LANGUAGE = "Spanish";
          // console.log("orignal lang es" + this.Updatepersonalinfo.LANGUAGE);
        } else {
          // console.log("lang update en" + language);
          this.Updatepersonalinfo.LANGUAGE = "English";
          // console.log("orignal lang en" + this.Updatepersonalinfo.LANGUAGE);
        }
      }
    });

    this.GetRacesDropdown(this.patientpersonalinfo.PATIENT_ACCOUNT, this.patientpersonalinfo.PRACTICE_CODE);
    this.GetEnthincitiesDropdowns(this.patientpersonalinfo.PATIENT_ACCOUNT, this.patientpersonalinfo.PRACTICE_CODE);
    this.GetLanguageDropdowns(this.patientpersonalinfo.PATIENT_ACCOUNT, this.patientpersonalinfo.PRACTICE_CODE);
    this.GetPatientEthnicities(this.patientpersonalinfo.PATIENT_ACCOUNT, this.patientpersonalinfo.PRACTICE_CODE);
    this.GetPatientPharmacies(this.patientpersonalinfo.PATIENT_ACCOUNT, this.patientpersonalinfo.PRACTICE_CODE);
    this.UpdateinfoService.onIsEditProfilePic();
    //this.getaddressbySMarty();
    this._phrutilService.patientlanguage$.subscribe(language => {
      console.log("dafault " + language);
      if (language === 'es') {
        this._phrutilService.setTitle('Demografía');
      } else if (language === 'hi') {
        this._phrutilService.setTitle('जनसांख्यिकी');
      }
      else if (language === 'ur') {
        this._phrutilService.setTitle('ڈیموگرافکس');
      }
      else {
        this._phrutilService.setTitle('Demographics');
      }
    });

  }

  //getaddressbySMarty() {
  //  this.smarty.getAutoCompleteSuggestions('1 Santa Claus').then((res: any) => {
  //    this.addressOptions = res as any[];
  //    console.log(this.addressOptions);
  //  })
  //}

  dNoneAddress: boolean = true;
  SearchAdressBySmartyAPi(str: any) {

    if (str.target.value.length > 3) {
      this.isLoading = true;
      this.dNoneAddress = this.Updatepersonalinfo.ADDRESS?.length > 0 ? false : true;
      this.smarty.getAutoCompleteSuggestions(str.target.value, this.practiceState, this.practiceCity).then((res: any) => {
        this.addressOptions = res as any[];

        this.isLoading = false;
      })
    }
  }
  setAddressOption(item: any) {

    this.Updatepersonalinfo.STATE = item.state;
    this.Updatepersonalinfo.CITY = item.city;
    this.onFocusOutZIPFinancial(item.zipcode, 1)
    this.Updatepersonalinfo.ADDRESS = item.streetLine;
    this.addresssline1 = false;
  }

  GetPatientEthnicities(PATIENT_ACCOUNT: any, PRACTICE_CODE: any) {
    this.spinner.show();
    this.UpdateinfoService.GetPatientEthnicities(PATIENT_ACCOUNT, PRACTICE_CODE).subscribe((res: any) => {
      this.spinner.hide();
      this.GetETHNICITIES = res.Data.ETHNICITIES as GetETHNICITIES[];
      if (this.GetETHNICITIES?.length == 2) {
        this.Updatepersonalinfo.ETHNICITY = this.GetETHNICITIES[0];
        this.Updatepersonalinfo.ETHNICITY2 = this.GetETHNICITIES[1];
      }
      else if (this.GetETHNICITIES?.length == 1) {
        this.Updatepersonalinfo.ETHNICITY = this.GetETHNICITIES[0];
        this.Updatepersonalinfo.ETHNICITY2 = '';
      }
      else {
        this.Updatepersonalinfo.ETHNICITY = '';
        this.Updatepersonalinfo.ETHNICITY2 = '';
      }


    }, (error: any) => {
      this.spinner.hide();
    })
  }
  totalPharmacyRecord: any = 0;
  GetPatientPharmacies(PATIENT_ACCOUNT: any, PRACTICE_CODE: any) {
    this.spinner.show();
    this.UpdateinfoService.GetPatientPharmacies(PATIENT_ACCOUNT, PRACTICE_CODE).subscribe((res: any) => {
      this.spinner.hide();
      //this.Getpharmacies = res.RESPONSE as Getpharmacies[];
      this.Getpharmacies = res.Data as Getpharmacies[];
      this.Getpharmacies.map((item: Getpharmacies) => {
        item.PHARMACY_PHONE = item.PHARMACY_PHONE ? this._phrutilService.maskingPhoneNumer(item.PHARMACY_PHONE) : '';
      });
      this.totalPharmacyRecord = this.Getpharmacies?.length;

    }, (error: any) => {
      this.spinner.hide();
    })
  }
  checPharmacyName: any = [];
  SetPharmaciesList(pharmacy: any) {


    this.checPharmacyName = [];
    let ss = pharmacy.pharmacyCode;
    this.checPharmacyName = this.Getpharmacies.filter((e: any) => e.PHARMACY_CODE == ss);
    if (this.checPharmacyName?.length > 0) {
      this.pharmaciesSearch = '';
      let text = "Selected pharmacy already exists, please try again";
      this.translateService.get('Alerts.pharmacy_already_exist').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showInfo(text)
      //this._phrutilService.showInfo("Selected pharmacy already exists, please try again");
      return false;
    }
    let tt = this.totalPharmacyRecord + 1;
    if (tt > 3) {
      this.pharmaciesSearch = '';
      let text = "Maximum three pharmacies can be added";
      this.translateService.get('Alerts.maximum_pharmacy').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showInfo(text)
      //this._phrutilService.showInfo("Maximum three pharmacies can be added");
      return false;
    } else {
      let Getpharmaciesdummy = new Getpharmacies();
      if (!this.Getpharmacies[0]) {
        Getpharmaciesdummy.PHARMACY_CODE = pharmacy.pharmacyCode;
        Getpharmaciesdummy.PHARMACY_NAME = pharmacy.pharmacyName;
        Getpharmaciesdummy.PHARMACY_ADDRESS = pharmacy.pharmacyAddress;
        Getpharmaciesdummy.PHARMACY_STATE = pharmacy.pharmacyState;
        Getpharmaciesdummy.PHARMACY_ZIP = pharmacy.pharmacyZip;
        Getpharmaciesdummy.PHARMACY_PHONE = pharmacy.pharmacyPhone;
        this.Getpharmacies.push(Getpharmaciesdummy);
        this.totalPharmacyRecord = this.totalPharmacyRecord + 1;
        this.pharmaciesSearch = '';

      } else if (!this.Getpharmacies[1]) {

        Getpharmaciesdummy.PHARMACY_CODE = pharmacy.pharmacyCode;
        Getpharmaciesdummy.PHARMACY_NAME = pharmacy.pharmacyName;
        Getpharmaciesdummy.PHARMACY_ADDRESS = pharmacy.pharmacyAddress;
        Getpharmaciesdummy.PHARMACY_STATE = pharmacy.pharmacyState;
        Getpharmaciesdummy.PHARMACY_ZIP = pharmacy.pharmacyZip;
        Getpharmaciesdummy.PHARMACY_PHONE = pharmacy.pharmacyPhone;
        this.Getpharmacies.push(Getpharmaciesdummy);
        this.totalPharmacyRecord = this.totalPharmacyRecord + 1;
        this.pharmaciesSearch = '';
      } else if (!this.Getpharmacies[2]) {
        Getpharmaciesdummy.PHARMACY_CODE = pharmacy.pharmacyCode;
        Getpharmaciesdummy.PHARMACY_NAME = pharmacy.pharmacyName;
        Getpharmaciesdummy.PHARMACY_ADDRESS = pharmacy.pharmacyAddress;
        Getpharmaciesdummy.PHARMACY_STATE = pharmacy.pharmacyState;
        Getpharmaciesdummy.PHARMACY_ZIP = pharmacy.pharmacyZip;
        Getpharmaciesdummy.PHARMACY_PHONE = pharmacy.pharmacyPhone;
        this.Getpharmacies.push(Getpharmaciesdummy);
        this.totalPharmacyRecord = this.totalPharmacyRecord + 1;
        this.pharmaciesSearch = '';
      }
    }
    return true;
  }
  setLanguageFormDropdown() {
    if (this.Updatepersonalinfo.LANGUAGE === '') {
      let lang = localStorage.getItem('language');
      if (lang == "es") {
        this.Updatepersonalinfo.LANGUAGE = "Spanish";
      } else {
        this.Updatepersonalinfo.LANGUAGE = "English";
      }
    } else {
      const languageCodePattern = /\s+\(\w{2}\)$/;
      if (languageCodePattern.test(this.Updatepersonalinfo.LANGUAGE)) {
        this.Updatepersonalinfo.LANGUAGE = this.Updatepersonalinfo.LANGUAGE.replace(languageCodePattern, '');
      }
    }

  }
  isGender: boolean = true;
  GetPatientData() {

    this.Updatepersonalinfo.PATIENT_ACCOUNT = this.patientpersonalinfo.PATIENT_ACCOUNT.toString();
    this.Updatepersonalinfo.PRACTICE_CODE = this.patientpersonalinfo.PRACTICE_CODE.toString();
    this.Updatepersonalinfo.ADDRESS = this.patientpersonalinfo.ADDRESS;
    this.Updatepersonalinfo.ZIP = this.patientpersonalinfo.ZIP;
    if (this.patientpersonalinfo.ZIP) {
      let zipCode = this.patientpersonalinfo.ZIP;
      zipCode = zipCode.substring(0, 5);
      this.zipCodeForDisplay = zipCode;
      console.log(this.zipCodeForDisplay);
    }
    this.Updatepersonalinfo.HOME_PHONE = this.patientpersonalinfo.HOME_PHONE ? this._phrutilService.maskingPhoneNumer(this.patientpersonalinfo.HOME_PHONE) : '';
    this.Updatepersonalinfo.WORK_PHONE = this.patientpersonalinfo.BUSINESS_PHONE ? this._phrutilService.maskingPhoneNumer(this.patientpersonalinfo.BUSINESS_PHONE) : '';
    this.Updatepersonalinfo.CITY = this.patientpersonalinfo.CITY;
    this.Updatepersonalinfo.STATE = this.patientpersonalinfo.STATE;
    this.Updatepersonalinfo.EMAIL_ADDRESS = this.patientpersonalinfo.EMAIL_ADDRESS;
    this.Updatepersonalinfo.CELL_PHONE = (this.patientpersonalinfo.CELL_PHONE && this.patientpersonalinfo.CELL_PHONE?.length > 0) ? this._phrutilService.maskingPhoneNumer(this.patientpersonalinfo.CELL_PHONE) : '';
    this.Updatepersonalinfo.LANGUAGE = this.patientpersonalinfo.LANGUAGES ? this.patientpersonalinfo.LANGUAGES : '';
    this.setLanguageFormDropdown();
    if (this.patientpersonalinfo.GENDER) {
      this.Updatepersonalinfo.GENDER = this.patientpersonalinfo.GENDER.toLowerCase();
    } else {
      this.Updatepersonalinfo.GENDER = this.patientpersonalinfo.GENDER;
    }
     
   // console.log("GENDER ", this.Updatepersonalinfo.GENDER);
   // this.Updatepersonalinfo.GENDER = "";
   // console.log('GENDER:', this.Updatepersonalinfo.GENDER);
   // console.log('GENDER per:', this.patientpersonalinfo.GENDER);
    //if (this.patientpersonalinfo.GENDER) {
    //  this.isGender = true;
    //  console.log('GENDER:', this.Updatepersonalinfo.GENDER);
    //  this.Updatepersonalinfo.GENDER = this.patientpersonalinfo.GENDER;
    //} else {
    //  this.isGender = false;
    //  console.log('GENDER:', this.Updatepersonalinfo.GENDER);
    //  this.Updatepersonalinfo.GENDER = this.patientpersonalinfo.GENDER;
    //}
    this.cell_phone_formated = (this.patientpersonalinfo.CELL_PHONE && this.patientpersonalinfo.CELL_PHONE?.length > 0) ? this._phrutilService.maskingPhoneNumer(this.patientpersonalinfo.CELL_PHONE) : '';
    let races: any;
    if (this.patientpersonalinfo.RACE) {
      races = (this.patientpersonalinfo.RACE?.length > 1 ? this.patientpersonalinfo.RACE : '');
    }
    if (races) {
      let aa = races.split(',');
      if (aa[0]) {
        this.race1 = aa[0].trim();
      }
      if (aa[1]) {
        this.race2 = aa[1].trim();
      }
      if (aa[2]) {
        this.race3 = aa[2].trim();
      }
    }
    if (this.patientpersonalinfo.CELL_PHONE == null || this.patientpersonalinfo.CELL_PHONE == '') {
      this.isCellPhoneAvailable = false;
    }
    this.onFocusOutZIPFinancial(this.patientpersonalinfo.ZIP, 1);
  }

  isZipCodeNotValidFinancialInfo: boolean = false;
  onFocusOutZIPFinancial(data: any, type: any) {

    let zipcode;
    if (type == 1) {
      if (data) {
        zipcode = data.replace(/\D/g, '');
        this.zipCodeForDisplay = zipcode.substring(0, 5);
        zipcode = this._phrutilService.maskingZipNum(zipcode);
        this.Updatepersonalinfo.ZIP = zipcode;

        //  console.log("focus out zip ", this.Updatepersonalinfo.ZIP)
      } else {
        zipcode = "";
      }
    } else {
      let phoneNumDigits;
      if (data) {
        phoneNumDigits = data.value.replace(/\D/g, '');
        this.zipCodeForDisplay = phoneNumDigits.substring(0, 5);
        phoneNumDigits = this._phrutilService.maskingZipNum(phoneNumDigits);
        data.value = phoneNumDigits;
        zipcode = data.value;
        this.Updatepersonalinfo.ZIP = zipcode;
        // console.log("focus out zip ", this.Updatepersonalinfo.ZIP)
      } else {
        zipcode = "";
        phoneNumDigits = "";
      }
    }
    zipcode = zipcode.replace(/\D/g, '');
    if (zipcode && (zipcode?.length == 5 || zipcode?.length == 9)) {
      this.spinner.show();
      // this.CityandStateRequest.ZIP_CODE = zipcode;
      this.UpdateinfoService.getZipCityState(zipcode, this.patientpersonalinfo.PATIENT_ACCOUNT, this.patientpersonalinfo.PRACTICE_CODE).subscribe((res: any) => {
        this.spinner.hide();
        if (res.data && res.data?.length > 0) {
          this.isZipCodeNotValidFinancialInfo = false;
          this.isZipCode = false;
          this._cityandstate = res.data;
          if (type == 0) {
            this.Updatepersonalinfo.CITY = this._cityandstate[0].cityName;
            this.Updatepersonalinfo.STATE = this._cityandstate[0].stateCode;
          } else
            if (type == 1) {
              this._cityandstate?.map((res: any) => {
                if (res.cityName.toLowerCase().trim() == this.Updatepersonalinfo.CITY.toLowerCase().trim())
                  this.Updatepersonalinfo.CITY = res.cityName.trim();
                if (res.stateCode.toLowerCase().trim() == this.Updatepersonalinfo.STATE.toLowerCase().trim())
                  this.Updatepersonalinfo.STATE = res.stateCode.trim();

              });

            }
        } else {
          this.Updatepersonalinfo.CITY = "";
          this.Updatepersonalinfo.STATE = "";
          this.isZipCodeNotValidFinancialInfo = true;
        }
      },
        (error: any) => {
          this.isZipCodeNotValidFinancialInfo = true;
          this.Updatepersonalinfo.CITY = "";
          this.Updatepersonalinfo.STATE = "";
          this.spinner.hide();
        })
    }
    else {
      this.Updatepersonalinfo.CITY = '';
      this.Updatepersonalinfo.STATE = '';
      this._cityandstate = [];
    }
  }
  GetRacesDropdown(PATIENT_ACCOUNT: any, PRACTICE_CODE: any) {
    this.spinner.show();
    this.UpdateinfoService.GetracesDropdown(PATIENT_ACCOUNT, PRACTICE_CODE).subscribe((res: any) => {
      this.spinner.hide();
      if (res) {
        this.getRacesDropdownsModel = res.data as GetRacesDropdownsModel;
      }
    }, (error: any) => {
      this.spinner.hide();
    });

  }
  enthincitiesSearch: any;
  pharmaciesSearch: any;
  ValidatePersonalInfo(data: any, type: any) {
    let validname = data.target.value.replace(/[^a-zA-Z ]/g, "");
    data.target.value = validname;
    if (type == 'language') {
      this.Updatepersonalinfo.LANGUAGE = validname;
      this.isLanguage = false;

    } else if (type == 'ethn') {
      this.enthincitiesSearch = validname

    } else if (type == 'race') {
      this.RacesSearch = validname;
    }
  }
  dNoneRaces: boolean = true;
  SearchRacesList(data: any) {
    let validname = data.value.replace(/[^a-zA-Z ]/g, "");
    if (validname) {
      this.dNoneRaces = false;
      data.value = validname;
      this.isLoading = true;
      if (this.getRacesDropdownsModel?.length > 0) {
        //let all = this.getRacesDropdownsModel.filter((x: any) => x.race.toLowerCase().match(new RegExp("^" + data.value + ".*$")));
        let all = this.getRacesDropdownsModel.filter((x: any) => x.race.toLowerCase().includes(data.value.toLowerCase()));
        if (all) {
          this.filterSearchRacesList = all;
        }
        this.isLoading = false;
      }
    }
    else
      this.dNoneRaces = true;
  }
  SetRacesList(item: any) {


    if (item) {
      var all = this.filterSearchRacesList.filter((x: any) => x.race.toLowerCase() == item.toLowerCase());
      if (all != undefined && all != null && all?.length > 0) {
        let aa = all[0].race;
        if (aa?.length > 0) {
          let bb = aa.split('(');
          let checkDuplicate = bb[0].trim();
          if (checkDuplicate == this.race1.trim()) {
            this.RacesSearch = "";
            let text = "The record already exists";
            this.translateService.get('Alerts.record_already_exist').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showInfo(text)
            //this._phrutilService.showInfo("The record already exists");
            return false;
          } else if (checkDuplicate == this.race2.trim()) {
            this.RacesSearch = "";
            let text = "The record already exists";
            this.translateService.get('Alerts.record_already_exist').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showInfo(text)
            //this._phrutilService.showInfo("The record already exists");
            return false;
          } else if (checkDuplicate == this.race3.trim()) {
            this.RacesSearch = "";
            let text = "The record already exists";
            this.translateService.get('Alerts.record_already_exist').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showInfo(text)
            //this._phrutilService.showInfo("The record already exists");
            return false;
          }
          else {
            if (this.race1 == "" || this.race1 == undefined) {
              this.RacesSearch = "";
              if (this.race1?.length < 1) {
                this.race1 = bb[0];
              } else
                if (this.race2?.length < 1) {
                  this.race2 = bb[0];
                } else
                  if (this.race3?.length < 1) {
                    this.race3 = bb[0];
                  }
            } else if (this.race2 == "" || this.race2 == undefined) {
              this.RacesSearch = "";
              if (this.race1?.length < 1) {
                this.race1 = bb[0];
              } else
                if (this.race2?.length < 1) {
                  this.race2 = bb[0];
                } else
                  if (this.race3?.length < 1) {
                    this.race3 = bb[0];
                  }
            } else if (this.race3 == "" || this.race3 == undefined) {
              this.RacesSearch = "";
              if (this.race1?.length < 1) {
                this.race1 = bb[0];
              } else
                if (this.race2?.length < 1) {
                  this.race2 = bb[0];
                } else
                  if (this.race3?.length < 1) {
                    this.race3 = bb[0];
                  }
            }
            else {
              this.RacesSearch = "";
              let text = "Maximum three races can be added";
              this.translateService.get('Alerts.maximum_races').subscribe((translation: string) => {
                text = translation;
              });
              this._phrutilService.showInfo(text);
              //this._phrutilService.showInfo("Maximum three races can be added");
              return false;
            }
          }
        }
      }
    }
    return true;
  }
  RemoveRacedata(param: string) {
    if (param == "race1") {
      this.race1 = "";
    } else if (param == "race2") {
      this.race2 = "";
    } else if (param == "race3") {
      this.race3 = "";
    }
  }
  onFocusOutCity(event: any) {

    let data = event.value;
    this._cityandstate?.map((res: any) => {
      if (res.cityName == data) {
        this.Updatepersonalinfo.CITY = res.cityName;
        this.Updatepersonalinfo.STATE = res.stateCode;
      }
    })
  }
  onFocusOutGender(data: any) {

    if (data.value) {
      this.Updatepersonalinfo.GENDER = data.value;
      this.isGenderSelected = true;
    }

  }
  filterSearchEnthincitiesList: any;
  filterSearchPharmaciesList: any;
  keyPressNumbers(event: any) {
    this._phrutilService.keyPressNumbers(event);
  }
  searchEnthincitiesFC: any;
  searchPharmaciesFC: any;
  dNoneethnicity: boolean = true;
  SearchEnthincitiesList(str: any) {

    if (str) {
      this.dNoneethnicity = this.enthincitiesSearch?.length > 0 ? false : true;
      if (str.keyCode == 40 || str.keyCode == 39 || str.keyCode == 38 || str.keyCode == 37) {
        return false;
      }
      this.isLoading = true;
      if (this.getEnthincitiesDropdownsModel?.length > 0) {
        //let all = this.getEnthincitiesDropdownsModel.filter((x: any) => x.ethnicities.toLowerCase().match(new RegExp("^" + this.enthincitiesSearch + ".*$")));
        let all = this.getEnthincitiesDropdownsModel.filter((x: any) => x.ethnicities.toLowerCase().includes(this.enthincitiesSearch.toLowerCase()));
        if (all) {
          this.filterSearchEnthincitiesList = all;
        }
        this.isLoading = false;
      }
    }
    return true;
  }
  isShowplaceholder: any = true;
  dNonePharmacy: boolean = true;
  SearchPharmacyList(str: any) {


    if (str && str.target.value && str.target.value?.length > 0) {
      if (str.keyCode == 40 || str.keyCode == 39 || str.keyCode == 38 || str.keyCode == 37) {
        this.isShowplaceholder = true;
        return false;
      }
      this.dNonePharmacy = false;
      this.isShowplaceholder = false;
      this.isLoading = true;
      this.filterSearchPharmaciesList = [];
      // if (this.getEnthincitiesDropdownsModel?.length > 0) {
      //   let all = this.getEnthincitiesDropdownsModel.filter((x: any) => x.ethnicities.toLowerCase().match(new RegExp("^" + this.enthincitiesSearch + ".*$")));
      //   if (all) {
      //     this.filterSearchEnthincitiesList = all;
      //   }
      this.SearchPatientPharmacyModel.pharmacyTopRecord = '45';
      //this.SearchPatientPharmacyModel.pharmacyZip=this.Updatepersonalinfo.ZIP?this.Updatepersonalinfo.ZIP:'';
      let search = str.target.value;
      if (/^\d+$/.test(search)) {
        this.SearchPatientPharmacyModel.pharmacyZip = search;
        this.SearchPatientPharmacyModel.pharmacyName = '';
      } else if (/^[a-zA-Z]+$/.test(search)) {
        if (this.Updatepersonalinfo.ZIP) {
          this.SearchPatientPharmacyModel.pharmacyZip = this.Updatepersonalinfo.ZIP
        } else if (this.practiceZip) {
          this.SearchPatientPharmacyModel.pharmacyZip = this.practiceZip
        } else {
          this.SearchPatientPharmacyModel.pharmacyZip = '';
        }
        //this.SearchPatientPharmacyModel.pharmacyZip = '';
        this.SearchPatientPharmacyModel.pharmacyName = search;
      } else {
        this.SearchPatientPharmacyModel.pharmacyZip = '';
        this.SearchPatientPharmacyModel.pharmacyName = str.target.value;
      }
      //this.SearchPatientPharmacyModel.pharmacyZip='';
      if (/^\d+$/.test(search)) {
        this.SearchPatientPharmacyModel.pharmacyState = '';
        this.SearchPatientPharmacyModel.pharmacyCity = '';
      } else {
        if (this.Updatepersonalinfo.STATE) {
          this.SearchPatientPharmacyModel.pharmacyState = this.Updatepersonalinfo.STATE
        } else if (this.practiceState) {
          this.SearchPatientPharmacyModel.pharmacyState = this.practiceState
        } else {
          this.SearchPatientPharmacyModel.pharmacyState = '';
        }

        if (this.Updatepersonalinfo.CITY) {
          this.SearchPatientPharmacyModel.pharmacyCity = this.Updatepersonalinfo.CITY
        } else if (this.practiceCity) {
          this.SearchPatientPharmacyModel.pharmacyCity = this.practiceCity
        } else {
          this.SearchPatientPharmacyModel.pharmacyCity = '';
        }
      }

      // this.SearchPatientPharmacyModel.pharmacyState = (this.Updatepersonalinfo.STATE ? this.Updatepersonalinfo.STATE : this.practiceState);
      //this.SearchPatientPharmacyModel.pharmacyCity = this.Updatepersonalinfo.CITY;
      // this.SearchPatientPharmacyModel.pharmacyCity = (this.Updatepersonalinfo.CITY ? this.Updatepersonalinfo.CITY : this.practiceCity);;

      // this.SearchPatientPharmacyModel.pharmacyState = (this.selectedState == 'state' ? this.Updatepersonalinfo.STATE : '');
      //if(this.SearchPatientPharmacyModel.pharmacyZip.length<5)
      //this.SearchPatientPharmacyModel.pharmacyState = this.Updatepersonalinfo.STATE ? this.Updatepersonalinfo.STATE:'';
      this.SearchPatientPharmacyModel.patientAccount = this.patientpersonalinfo.PATIENT_ACCOUNT;
      // this.SearchPatientPharmacyModel.pharmacyName = str.target.value;
      this.UpdateinfoService.SearchPatientPharmacy(this.SearchPatientPharmacyModel).subscribe((res: any) => {

        this.isLoading = false;
        if (res.statusCode == 200) {
          this.filterSearchPharmaciesList = res.data;
          this.filterSearchPharmaciesList.map((res1: any) => {
            res1.pharmacyZip = this._phrutilService.maskingZipNum(res1.pharmacyZip);
            res1.pharmacyPhone = this._phrutilService.maskingPhoneNumer(res1.pharmacyPhone);
          })
        } else {
          this.isLoading = false;
          this.filterSearchPharmaciesList = [];

        }
      }, (error: any) => {

        this.isLoading = false;
        this.filterSearchPharmaciesList = [];

      })

    } else {
      this.dNonePharmacy = true;
      this.isLoading = false;
      this.filterSearchPharmaciesList = [];
    }
    return true;
  }
  SetEnthincitiesList(item: any) {
    if (item) {
      var all = this.filterSearchEnthincitiesList.filter((x: any) => x.ethnicities.toLowerCase() == item.toLowerCase());
      if (all != undefined && all != null && all?.length > 0) {
        let aa = all[0].ethnicities;
        if (aa) {
          let bb = aa.split('(');
          let checkDuplicate = bb[0].trim();
          if (checkDuplicate == this.Updatepersonalinfo.ETHNICITY.trim()) {
            this.enthincitiesSearch = "";
            let text = "The record already exists";
            this.translateService.get('Alerts.record_already_exist').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showInfo(text)
            //this._phrutilService.showInfo("The record already exists");
            return false;
          } else if (checkDuplicate == this.Updatepersonalinfo.ETHNICITY2.trim()) {
            this.enthincitiesSearch = "";
            let text = "The record already exists";
            this.translateService.get('Alerts.record_already_exist').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showInfo(text)
            //this._phrutilService.showInfo("The record already exists");
            return false;
          }

          if (this.Updatepersonalinfo.ETHNICITY == "" || this.Updatepersonalinfo.ETHNICITY == undefined) {
            this.enthincitiesSearch = "";
            this.Updatepersonalinfo.ETHNICITY = bb[0].trim();
          } else if (this.Updatepersonalinfo.ETHNICITY2 == "" || this.Updatepersonalinfo.ETHNICITY2 == undefined) {
            this.enthincitiesSearch = "";
            this.Updatepersonalinfo.ETHNICITY2 = bb[0].trim();
          }
          else {
            this.enthincitiesSearch = "";
            let text = "Maximum two ethnicities can be added";
            this.translateService.get('Alerts.maximum_ethnicities').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showInfo(text)
            //this._phrutilService.showInfo("Maximum two ethnicities can be added");
            return false;
          }
        }
      }
    }
    return true;
  }

  GetEnthincitiesDropdowns(PATIENT_ACCOUNT: any, PRACTICE_CODE: any) {

    this.spinner.show();
    this.UpdateinfoService.GetEnthincitiesDropdowns(PATIENT_ACCOUNT, PRACTICE_CODE).subscribe((res: any) => {
      this.spinner.hide();
      if (res) {
        this.getEnthincitiesDropdownsModel = res.data as GetEnthincitiesDropdownsModel[];
      }
    }, (error: any) => {
      this.spinner.hide();
    })
  }
  RemoveEthnicitydata(param: string) {
    if (param == "ethnicity") {
      this.Updatepersonalinfo.ETHNICITY = "";
    } else if (param == "ethnicity2") {
      this.Updatepersonalinfo.ETHNICITY2 = "";
    }
  }

  filterSearchLanguageList: any;
  dNoneLanguage: boolean = true;

  SearchLanguageList(str: any) {
    if (str) {
      this.dNoneLanguage = this.Updatepersonalinfo.LANGUAGE?.length > 0 ? false : true;
      if (str.keyCode == 40 || str.keyCode == 39 || str.keyCode == 38 || str.keyCode == 37) {
        return false;
      }
      this.isLoading = true;
      if (this.getLanguageDropdownsModel?.length > 0) {
        //let all = this.getLanguageDropdownsModel.filter((x: any) => x.languages.toLowerCase().match(new RegExp("^" + this.Updatepersonalinfo.LANGUAGE.toLowerCase() + ".*$")));
        let all = this.getLanguageDropdownsModel.filter((x: any) => x.languages.toLowerCase().includes(this.Updatepersonalinfo.LANGUAGE.toLowerCase()));
        if (all?.length > 0) {
          this.filterSearchLanguageList = all;
          this.isLoading = false;
        }
        else {
          this.isLoading = false;
          this.filterSearchLanguageList = [];
        }
      }
    }
    return true;
  }

  isValidLanguage: any = false;
  CheckSearchLanguage(str: any) {
    if (str) {
      if (this.getLanguageDropdownsModel?.length > 0) {
        let all = this.getLanguageDropdownsModel.filter((x: any) => x.languages.split(' ')[0].toLowerCase() == str.toLowerCase());
        //  console.log(all);
        if (all != undefined && all != null && all?.length > 0) {
          let aa = all[0].languages;
          if (aa?.length > 0) {
            //     console.log(aa);
            let bb = aa.split('(');
            this.Updatepersonalinfo.LANGUAGE = bb[0].trim();
          }
          else {
            this.Updatepersonalinfo.LANGUAGE = this.patientpersonalinfo.LANGUAGES ? this.patientpersonalinfo.LANGUAGES : '';
            return true;
          }
        }
        else {
          this.Updatepersonalinfo.LANGUAGE = '';
          this.isValidLanguage = true;
          return false;
        }
      }
      else {
        this.Updatepersonalinfo.LANGUAGE = this.patientpersonalinfo.LANGUAGES ? this.patientpersonalinfo.LANGUAGES : '';
        return true;
      }
    }
    else {
      this.Updatepersonalinfo.LANGUAGE = this.patientpersonalinfo.LANGUAGES ? this.patientpersonalinfo.LANGUAGES : '';
      return true;
    }
    //  console.log(this.isValidLanguage)
    return true;
  }
  SetLanguageList(item: any) {

    if (item) {
      var all = this.filterSearchLanguageList.filter((x: any) => x.languages.toLowerCase() == item.toLowerCase());
      if (all != undefined && all != null && all?.length > 0) {
        let aa = all[0].languages;
        if (aa?.length > 0) {
          let bb = aa.split('(');
          this.Updatepersonalinfo.LANGUAGE = bb[0].trim();
          this.isValidLanguage = false;
        }
      }
    }
  }
  GetLanguageDropdowns(PATIENT_ACCOUNT: any, PRACTICE_CODE: any) {
    this.spinner.show();
    this.UpdateinfoService.GetLanguageDropdowns(PATIENT_ACCOUNT, PRACTICE_CODE).subscribe((res: any) => {
      this.spinner.hide();
      if (res) {
        this.getLanguageDropdownsModel = res.data as GetLanguageDropdownsModel[];
        this.getLanguageDropdownsModel.map((res: any) => {
          let bb = res.languages.split('(');
          res.languages = bb[0].trim();
        });
      }
    }, (error: any) => {
      this.spinner.hide();
    })
  }
  isValidPhone: boolean = true;
  isValidCellPhone: boolean = true;
  isValidFax: boolean = true;
  validatePhone(phoneNumDigits: any, type: any) {
    let dummyPhone = phoneNumDigits.replace(/\D/g, '');
    phoneNumDigits = dummyPhone.replace(/\s/g, '');
    if (type == "phone") {
      if (phoneNumDigits?.length == 0 || phoneNumDigits?.length == 14 || phoneNumDigits?.length == 10)
        this.isValidPhone = true;
      else
        this.isValidPhone = false;
    }
    else
      if (type == "fax") {
        if (phoneNumDigits?.length == 0 || phoneNumDigits?.length == 14 || phoneNumDigits?.length == 10)
          this.isValidFax = true;
        else
          this.isValidFax = false;
      } else if (type == "cell") {
        if (phoneNumDigits?.length == 0 || phoneNumDigits?.length == 14 || phoneNumDigits?.length == 10) {
          this.isValidCellPhone = true;
          this.iscellphone = false;
        }
        else
          this.isValidCellPhone = false;
      }
  }

  validatePhoneNo(field: any) {

    let phoneNumDigits = field.value.replace(/\D/g, '');
    field.value = phoneNumDigits;
    let isValidPhone = (phoneNumDigits?.length == 0 || phoneNumDigits?.length == 10);
    if (isValidPhone) {
      field.value = this._phrutilService.maskingPhoneNumer(phoneNumDigits);
    } else {
      field.value = phoneNumDigits;
    }
  }

  addresssline1: boolean = false;
  iscellphone: boolean = false;
  isGenderSelected: boolean = true;
  isLanguage: boolean = false;
  zipCodeForDisplay: any = '';
  UpdatePatientInfo() {
    this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PersonalInfo'));
    const hasExistingProfilePhoto = !!this.patientpersonalinfo.PICTURE_ADDRESS || !!localStorage.getItem('personalInfoPictureAddress');
    if (!hasExistingProfilePhoto && this.patientpersonalinfo.isEditProfilePic == true) {
      if (this.patientpersonalinfo.PRACTICE_CODE.toString() == '100' || this.patientpersonalinfo.PRACTICE_CODE.toString() == '1011163') {
        $("#ProfilePhoto-modal").modal("show");
        return false;
      } else {
        const photoShowed = localStorage.getItem("profilePhotoAlreadyShowed");
        if (photoShowed == 'yes') {
          // return false;
        } else {
          $("#ProfilePhoto-modal").modal("show");
          localStorage.setItem("profilePhotoAlreadyShowed", 'yes');
          return false;
        }

      }
    }

    if (this.Updatepersonalinfo.ZIP) {
      this.Updatepersonalinfo.ZIP = this.Updatepersonalinfo.ZIP.replace(/\D/g, '');
    }
    this.Updatepersonalinfo.PICTURE_ADDRESS = this.patientpersonalinfo.PICTURE_ADDRESS ? this.patientpersonalinfo.PICTURE_ADDRESS : '';

    if (this.Updatepersonalinfo.EMAIL_ADDRESS == null) {
      this.Updatepersonalinfo.EMAIL_ADDRESS = '';
    }
    if (!this.Updatepersonalinfo.ADDRESS || this.Updatepersonalinfo.ADDRESS == null) {
      this.addresssline1 = true;
      return false;
    }
    else {
      this.addresssline1 = false;
    }
    if (!this.Updatepersonalinfo.LANGUAGE || this.Updatepersonalinfo.LANGUAGE == null) {
      this.isLanguage = true;
      return false;
    }
    else {
      this.isLanguage = false;
    }
    if (!this.patientpersonalinfo?.CHECK_NOCELLPHONE && (!this.Updatepersonalinfo.CELL_PHONE || this.Updatepersonalinfo.CELL_PHONE == null || this.Updatepersonalinfo.CELL_PHONE == '')) {
      this.iscellphone = true;
      return false;
    }
    else {
      this.iscellphone = false;
    }
    if (!this.Updatepersonalinfo.GENDER || this.Updatepersonalinfo.GENDER == null || this.Updatepersonalinfo.GENDER == '') {
      this.isGenderSelected = false;
      return false;
    }
    else {
      this.isGenderSelected = true;
    }
    

    if (this.Updatepersonalinfo.ZIP == '' || this.Updatepersonalinfo.ZIP == undefined || this.Updatepersonalinfo.ZIP == null || (this.Updatepersonalinfo.ZIP?.length != 9 && this.Updatepersonalinfo.ZIP?.length != 5)) {
      this.isZipCodeNotValidFinancialInfo = true;
      return false;
    }
    if (!this.isZipCodeNotValidFinancialInfo) {
      if (!this.Updatepersonalinfo.ZIP) {
        this.isZipCode = true;
        return false;
      }

      else {
        this.isZipCode = false;
      }
    } else {
      return false;
    }
    if (!this.CheckSearchLanguage(this.Updatepersonalinfo.LANGUAGE)) {
      return false;
    }
    if (this.Updatepersonalinfo.HOME_PHONE && this.Updatepersonalinfo.HOME_PHONE?.length != 14) {
      let dummyPhone = this.Updatepersonalinfo.HOME_PHONE.replace(/\D/g, '');
      this.Updatepersonalinfo.HOME_PHONE = dummyPhone.replace(/\s/g, "");

    }
    if (this.Updatepersonalinfo.WORK_PHONE && this.Updatepersonalinfo.WORK_PHONE?.length != 14) {
      let dummyPhone = this.Updatepersonalinfo.WORK_PHONE.replace(/\D/g, '');
      this.Updatepersonalinfo.WORK_PHONE = dummyPhone.replace(/\s/g, "");
    }
    if (this.Updatepersonalinfo.CELL_PHONE && this.Updatepersonalinfo.CELL_PHONE?.length != 14) {
      let dummyPhone = this.Updatepersonalinfo.CELL_PHONE.replace(/\D/g, '');
      this.Updatepersonalinfo.CELL_PHONE = dummyPhone.replace(/\s/g, "");
    }

    this.validatePhone(this.Updatepersonalinfo.HOME_PHONE, 'phone');
    this.validatePhone(this.Updatepersonalinfo.WORK_PHONE, 'fax');
    this.validatePhone(this.Updatepersonalinfo.CELL_PHONE, 'cell');
    if (!this.isValidPhone || !this.isValidFax || !this.isValidCellPhone) {
      return false;
    }
    //if(!this.patientpersonalinfo.CELL_PHONE || this.patientpersonalinfo.CELL_PHONE?.length<1)
    //if((!this.Updatepersonalinfo.HOME_PHONE || this.Updatepersonalinfo.HOME_PHONE?.length < 1 ) && (!this.Updatepersonalinfo.WORK_PHONE || this.Updatepersonalinfo.WORK_PHONE?.length < 1))
    //{
    //  let text = "Enter Home or Work Phone";
    //  this.translateService.get('Alerts.enter_home_or_work_phone').subscribe((translation: string) => {
    //    text = translation;
    //  });
    //  this._phrutilService.showInfo(text)
    //  //this._phrutilService.showInfo("Enter Home or Work Phone");
    //  return;
    //}

    if (this.Updatepersonalinfo.HOME_PHONE?.length == 0 || this.Updatepersonalinfo.HOME_PHONE?.length == 14 || this.Updatepersonalinfo.HOME_PHONE?.length == 10)
      this.isValidPhone = true;
    else
      this.isValidPhone = false;

    if (!this.isValidPhone) {
      return false;
    }

    if (this.race1 || this.race2 || this.race3) {
      this.Updatepersonalinfo.RACE = (this.race1?.length > 1 ? this.race1.trim() : '') + (this.race2?.length > 1 ? (this.race1?.length > 1 ? ',' + this.race2.trim() : this.race2.trim()) : '') +
        (this.race3?.length > 1 ? (this.race1?.length > 1 || this.race2?.length > 1 ? ',' + this.race3.trim() : this.race3.trim()) : '');
    }
    else {
      this.Updatepersonalinfo.RACE = '';
    }
    let dummyPhone = this.Updatepersonalinfo.HOME_PHONE.replace(/\D/g, '');
    this.Updatepersonalinfo.HOME_PHONE = dummyPhone.replace(/\s/g, "");
    dummyPhone = this.Updatepersonalinfo.WORK_PHONE.replace(/\D/g, '');
    this.Updatepersonalinfo.WORK_PHONE = dummyPhone.replace(/\s/g, "");
    dummyPhone = this.Updatepersonalinfo.CELL_PHONE.replace(/\D/g, '');
    this.Updatepersonalinfo.CELL_PHONE = dummyPhone.replace(/\s/g, "");

    if (this.Getpharmacies?.length == 3) {
      this.Updatepersonalinfo.PHARMACY_ID = this.Getpharmacies[0].PHARMACY_CODE.toString();
      this.Updatepersonalinfo.PHARMACY2_ID = this.Getpharmacies[1].PHARMACY_CODE.toString();
      this.Updatepersonalinfo.PHARMACY3_ID = this.Getpharmacies[2].PHARMACY_CODE.toString();
    } else if (this.Getpharmacies?.length == 2) {
      this.Updatepersonalinfo.PHARMACY_ID = this.Getpharmacies[0].PHARMACY_CODE.toString();
      this.Updatepersonalinfo.PHARMACY2_ID = this.Getpharmacies[1].PHARMACY_CODE.toString();
    } else if (this.Getpharmacies.length == 1) {
      this.Updatepersonalinfo.PHARMACY_ID = this.Getpharmacies[0].PHARMACY_CODE.toString();
    }
    this.spinner.show();
    this.UpdateinfoService.UpdatePatientInfo(this.Updatepersonalinfo).subscribe((res: any) => {
    this.spinner.hide();
      //if (res.RESPONSE.MESSAGE.includes("Successfully"))
     if (res.Data.MESSAGE.includes("Successfully"))
      this.patientpersonalinfo.ADDRESS = this.Updatepersonalinfo.ADDRESS;
      this.patientpersonalinfo.CITY = this.Updatepersonalinfo.CITY;
      this.patientpersonalinfo.HOME_PHONE = this.Updatepersonalinfo.HOME_PHONE;
      this.patientpersonalinfo.BUSINESS_PHONE = this.Updatepersonalinfo.WORK_PHONE;
      this.patientpersonalinfo.LANGUAGES = this.Updatepersonalinfo.LANGUAGE
      this.patientpersonalinfo.RACE = this.Updatepersonalinfo.RACE
      this.patientpersonalinfo.STATE = this.Updatepersonalinfo.STATE
      this.patientpersonalinfo.ZIP = this.Updatepersonalinfo.ZIP
      this.patientpersonalinfo.CELL_PHONE = this.Updatepersonalinfo.CELL_PHONE
      this.patientpersonalinfo.EMAIL_ADDRESS = this.Updatepersonalinfo.EMAIL_ADDRESS
      this.patientpersonalinfo.GENDER = this.Updatepersonalinfo.GENDER
      this.patientpersonalinfo.isEditProfilePic = false
      let data = this._phrutilService.encrypt(this.patientpersonalinfo);
      localStorage.setItem('PersonalInfo', data);
      this.UpdateinfoService.onIsEditProfilePic();
      //this._phrutilService.showSuccess("Record has been updated");
      // this.route.navigateByUrl('patient/careteam');
      //console.log("UpdatePatientInfo", this.patientpersonalinfo);
      //console.log("this.patientpersonalinfo.practiceCode", this.patientpersonalinfo.PRACTICE_CODE)
      if (this.patientpersonalinfo.PRACTICE_CODE == '111') {
        localStorage.setItem("backFromCovid", "false");
        this.route.navigateByUrl('patient/intake');
      }
      else {
        this.route.navigateByUrl('patient/insurance');
      }
    }, (error: any) => {
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showError(text);
      //this._phrutilService.showError("Service is not available, please try later.");
    })
    return true;
  }
  ValidateAddress(inputName: any, type: any) {
    if (inputName.value.length > 0) {
      this.addresssline1 = false;

    }
    let validaddres = inputName.value.replace(/[^/#.0-9a-zA-Z\s,-]/g, "");
    inputName.value = validaddres;
    if (type == 'address') {
      this.Updatepersonalinfo.ADDRESS = validaddres
    } else if (type == 'pharmacy') {
      this.pharmaciesSearch = validaddres
    }
  }
  // changeState() {
  //   if (this.selectedState == 'All') {
  //     this.selectedState = 'state';
  //     this.pharmaciesSearch = '';
  //     this.filterSearchPharmaciesList = [];
  //   } else {
  //     this.selectedState = 'All';
  //     this.pharmaciesSearch = '';
  //     this.filterSearchPharmaciesList = [];
  //   }
  // }
  RemovePharmacyData(num: any) {
    this.Getpharmacies.splice(num, 1);
    this.totalPharmacyRecord -= 1;
  }
  emError1 = false;
  valEmailSearchAdd(e: any) {
    let regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    let v = regexp.test(e.target.value);

    if (v) {
      this.emError1 = false;
    }
    else {
      this.emError1 = true;
    }
    return true;
  }
}
